import { Box, Typography } from '@mui/material';
import HighRatingTileBackground from '../../assets/alert-tile-bg/high-rating.svg'
import HighMediumRatingTileBackground from '../../assets/alert-tile-bg/high-medium-rating.svg'
import MediumRatingTileBackground from '../../assets/alert-tile-bg/medium-rating.svg'
import LowRatingTileBackground from '../../assets/alert-tile-bg/low-rating.svg'

export default function AlertTile({
	code,
	label,
	severity,
}: {
	code: string;
	label: string;
	severity: string;
}) 
{

	const getBackground = () => {
		if(severity === 'High') return HighRatingTileBackground;
		if(severity === 'High-Medium') return HighMediumRatingTileBackground;
		if(severity === 'Medium') return MediumRatingTileBackground;
		return LowRatingTileBackground;
	}

	return (
		<Box
			// className={`alert ${severity.toLowerCase()}`}
			sx={{
				textAlign: 'center',
				lineHeight: 1,
				padding: '4vh 2vw',
				boxSizing: 'border-box',
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'space-around',
				alignItems: 'center',
				width: '17.5vw',
				aspectRatio: 1/0.72,
				background: `url('${getBackground()}')`,
				backgroundRepeat: 'no-repeat',
				backgroundSize: 'cover',
				'& > p, &>h6': {
					marginRight: 3,
				},
			}}
		>
			<Typography  fontWeight={500} width={'70%'}>
				{code}
			</Typography>
			<Typography fontWeight={'bold'} width={'70%'}>
				{label}
			</Typography>
			<Typography fontWeight={'bold'} fontStyle={'italic'}>
				{severity}
			</Typography>
		</Box>
	);
}
